import { useTranslation } from "react-i18next";
import SvgIcon from "./SvgIcon";

const SaveInputButtons = ({
  handleSave,
  handleDismiss,
  enabled = false,
  saveDisabled = false,
  actionText,
  showIcon = false,
}) => {
  const { t } = useTranslation("common");
  if (!enabled) return null;
  return (
    <div className="edit-confirm">
      <button
        onClick={handleSave}
        data-button-type="primary"
        disabled={saveDisabled}
      >
        {showIcon ? (
          <SvgIcon src="/img/new-icons/search.svg" noFilterOnLight={true} />
        ) : (
          actionText ?? t("save")
        )}
      </button>
      <button onClick={handleDismiss} data-button-type="secondary">
        <SvgIcon src="/img/new-icons/red-cross-20px.svg" />
      </button>
    </div>
  );
};

export default SaveInputButtons;
